import React from 'react'
import { connect } from 'react-redux'
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';

import MarkerHistoryPopup from './MarkerHistoryPopup';

const MarkerNode = (props) => {
	const handleSelectMarkerClick = (event) => {
		const { device_id, onSelectMarker } = props
		onSelectMarker(device_id)
	}

	const {
		map,
		location_lat,
		location_lng,
		icon_url,
		visible_icon,
		zIndex,
		name,
		showTripsHistory,
		status,
		vehiclesType,
	} = props;

	return (
		<MarkerWithLabel
			map={map}
			position={{ lat: Number(location_lat), lng: Number(location_lng) }}
			icon={{ url: icon_url }}
			visible={visible_icon}
			opacity={1}
			labelAnchor={new window.google.maps.Point(10, 35)}
			labelStyle={{ opacity: '0.8' }}
			labelInBackground
			zIndex={zIndex}
			optimized={false}
			draggable={false}
			onClick={handleSelectMarkerClick}
		>
			<>
				{vehiclesType !== 'equipment' ? (
					<div
						className={`map-price-marker ${status === 'parked' ? 'parking' : status === 'driving' ? '' : 'offline'} ${icon_url.includes('s_van') ? 's_van' : ''}`}>
						<span>{name}</span>
					</div>
				) : ''}

				{showTripsHistory
					&& (
						<MarkerHistoryPopup
							{...props}
						/>
					)}
			</>
		</MarkerWithLabel>
	)
}

const mapStateToProps = ({ dashboardData }) => ({
	showTripsHistory: dashboardData.showTripsHistory
});

export default connect(mapStateToProps)(MarkerNode);
